<div class="ok-procces" *ngIf="flashPaymentService.controller.operationSuccess">
    <div class="action-container">
      <div class="icon-confirmation-container">
        <img
          src="../../../../../assets/images/icon_confirmacion.png"
          alt=""
          class="image-confirmation"
        />
      </div>
      <div class="tex-confirmation-message">
        <div class="tex-confirmation-title">¡Gracias por tu pago!</div>
        <div class="tex-confirmation-text">
          Recibir&aacute;s un correo electr&oacute;nico con la
          confimaci&oacute;n de tu pago
        </div>
      </div>
    </div>
    <div class="line-decorator"></div>

    <div class="confirmation-table-container">
      <div class="confirmation-header">
        <div class="confirmation-date">{{flashPaymentService.controller.today | date: 'short' }}</div>
        <div class="confirmation-authorization">
          #Autorizaci&oacute;n <strong>{{flashPaymentService.controller.authorizationNumber }}</strong>
        </div>
      </div>
      <div class="confiramtion-content">
        <div class="confirmation-box">
          <div class="box-title"># Cuenta</div>
          <div class="box-item">{{flashPaymentService.controller.accountNumber}}</div>
        </div>
        <div class="confirmation-box">
          <div class="box-title">M&eacute;todo de pago</div>
          <div class="box-item" *ngIf="flashPaymentService.controller.paymentMethod === ''">
            <img
              src="../../../../../assets/images/icon_tarjeta_1.png"
              alt=""
              *ngIf="flashPaymentService.controller.isCard"
              class="img-step1"
            />

            <img
              class="img-fix"
              src="../../../../../assets/images/icon_wallet_2.png"
              alt=""
              *ngIf="flashPaymentService.controller.isPlaceToPay"
              class="img-step1"
            />

            <img
              src="../../../../../assets/images/icon_ACH_1.png"
              alt=""
              *ngIf="flashPaymentService.controller.isACH"
              class="img-step1"
            />

          </div>

          <div class="box-item" *ngIf="flashPaymentService.controller.paymentMethod !== ''">
            <img
              *ngIf="flashPaymentService.controller.paymentMethod === 'V'"
              class="card-img-result"
              src="../../../../../assets/images/Payment Method/Visa.png"
              alt=""
            />
            <img
              *ngIf="flashPaymentService.controller.paymentMethod === 'M'"
              class="card-img-result"
              src="../../../../../assets/images/Payment Method/Mastercard.png"
              alt=""
            />
            <img
              *ngIf="flashPaymentService.controller.paymentMethod === 'A'"
              class="card-img-result"
              src="../../../../../assets/images/Payment Method/Amex.png"
              alt=""
            />
            <img
              *ngIf="flashPaymentService.controller.paymentMethod === 'X'"
              class="card-img-result"
              src="../../../../../assets/images/Payment Method/ath.png"
              alt=""
            />
          </div>
        </div>
        <div class="confirmation-box">
          <div class="box-title"># Referencia</div>
          <div class="box-item">{{flashPaymentService.controller.confirmationNumber}}</div>
        </div>
        <div class="confirmation-box">
          <div class="box-title">Estado</div>
          <div class="box-item">{{flashPaymentService.controller.paymentStatusDesription}}</div>
        </div>
        <div class="confirmation-box last-box">
          <div class="box-title">Monto Total</div>
          <div class="box-item">{{flashPaymentService.controller.operationAmount | currency}}</div>
        </div>
      </div>
    </div>

    <div class="line-decorator" *ngIf="flashPaymentService.controller.showSubscriptionOption"></div>

<!--    <div class="text-center" *ngIf="flashPaymentService.controller.showSubscriptionOption">-->
<!--      <div-->
<!--        class="text-container add-text"-->
<!--        (click)="flashPaymentService.buildAuthorizationRequest(false, true)"-->
<!--      >-->
<!--        <span><img src="../../../../../assets/images/icon_add.png" alt=""/></span>-->
<!--        &nbsp;<span class="susc-link">Ahora es facil pagar en claro, presione el siguiente enlace si desea guardar su tarjeta para el pago de sus pr&oacute;ximas facturas</span>-->
<!--      </div>-->
<!--    </div>-->


<!--    <div class="line-decorator"></div>-->
<!--    <div class="action-container">-->
<!--      <div class="send-container">-->
<!--        <span class="action-item">-->
<!--          <mat-icon> email</mat-icon> &nbsp;&nbsp; Enviar Correo-->
<!--          Electr&oacute;nico-->
<!--        </span>-->
<!--        <span class="action-item">-->
<!--          <mat-icon> textsms</mat-icon> &nbsp;&nbsp; Enviar sms-->
<!--        </span>-->
<!--      </div>-->
<!--    </div>-->
  </div>
